module.exports = __webpack_public_path__ + "img/account.cc9c7abe.svg";